// Additional Information tab — Teletalk-style eligibility / requirement questions.
// `ns: 'af'` → i18n keys under sohozJob.af.<name>. Yes/No values match gov forms.

const YES_NO = [{ value: 'Yes', key: 'yes' }, { value: 'No', key: 'no' }];
const NS = 'af';

const yn = (name, revealField) => ({
    name,
    ns: NS,
    type: 'select',
    colSpan: 'full',
    options: YES_NO,
    ...(revealField ? { reveal: { values: ['Yes'], field: { ...revealField, ns: NS } } } : {}),
});

const text = (name, max = 120) => ({ name, ns: NS, v: 'text', max, colSpan: 'full' });
const num = (name, max = 3) => ({ name, ns: NS, type: 'number', v: 'number', max, colSpan: 'full' });

export const ADDITIONAL_FIELDS = [
    yn('exp_10y_cf_6y_livelihood'),
    yn('exp_7y_cf_4y_livelihood'),
    yn('exp_7y_finance_accounts_4y_dev'),
    yn('exp_7y_env_safeguards_4y_construction'),
    yn('exp_community_finance', { name: 'exp_community_finance_years', labelKey: 'years', ...num('exp_community_finance_years') }),
    yn('exp_livelihoods', { name: 'exp_livelihoods_years', labelKey: 'years', ...num('exp_livelihoods_years') }),
    yn('exp_7y_monitoring_eval_4y_dev'),
    yn('exp_5y_monitoring_eval_dev'),
    yn('exp_5y_ultra_poor_group_credit_livelihood_dev'),
    yn('exp_poor_capacity_employment_dev'),
    yn('exp_construction_env_safeguard'),
    yn('diploma_6mo_computer'),
    yn('exp_mel_mis_dev'),
    yn('physical_fitness_guard'),
    yn('exp_office_cleaning'),
    yn('degree_science'),
    yn('exp_3y_relevant_field'),
    yn('knowledge_computer'),
    yn('exp_poverty_microcredit'),
    yn('exp_computer_loan_operations'),
    yn('driving_license_2y_exp'),
    yn('exp_15y_first_grade_3y_joint_director'),
    yn('research_pubs_8'),
    yn('exp_12y_first_grade_5y_deputy_director'),
    yn('research_pubs_6'),
    yn('exp_7y_asst_director_9th_grade'),
    yn('research_pubs_4'),
    yn('bmdc_registered', { name: 'bmdc_registration_number', labelKey: 'registration_number', ...num('bmdc_registration_number', 30) }),
    yn('diploma_library_science', { name: 'diploma_library_science_institute', labelKey: 'institute_name', ...text('diploma_library_science_institute') }),
    yn('bped_degree', { name: 'bped_institute_passing_year', labelKey: 'degree_institute_passing_year', ...text('bped_institute_passing_year', 150) }),
    yn('cert_6mo_computer_bteb', { name: 'cert_6mo_computer_bteb_institute', labelKey: 'institute_name', ...text('cert_6mo_computer_bteb_institute') }),
    yn('exp_min_3y'),
    yn('typing_speed_20_en_20_bn'),
    yn('trade_cert_mechanical', { name: 'trade_cert_mechanical_institute', labelKey: 'institute_name', ...text('trade_cert_mechanical_institute') }),
    yn('good_health'),
    yn('practical_exp_related_works'),
    yn('typing_speed_25_bn_30_en'),
    yn('efficiencies_computer'),
    yn('efficiencies_word_email_fax'),
    yn('valid_light_motor_license', { name: 'valid_light_motor_license_number', labelKey: 'license_number', ...text('valid_light_motor_license_number', 60) }),
    yn('exp_ms_word_powerpoint_excel'),
    yn('diploma_silk_technology', { name: 'diploma_silk_technology_institute', labelKey: 'diploma_institute_name', ...text('diploma_silk_technology_institute') }),
    yn('trade_cert_civil_drafting_6mo', { name: 'trade_cert_civil_drafting_institute', labelKey: 'trade_course_institute', ...text('trade_cert_civil_drafting_institute') }),
    yn('light_heavy_driving_license', { name: 'light_heavy_driving_license_number', labelKey: 'license_number', ...text('light_heavy_driving_license_number', 60) }),
    yn('valid_driving_license', { name: 'valid_driving_license_number', labelKey: 'license_number', ...text('valid_driving_license_number', 60) }),
    yn('typing_speed_30_en_25_bn', { name: 'typing_speed_30_en_25_bn_speed', labelKey: 'speed', ...text('typing_speed_30_en_25_bn_speed', 60) }),
    yn('steno_speed_50_bn_80_en', { name: 'steno_speed_50_bn_80_en_speed', labelKey: 'speed', ...text('steno_speed_50_bn_80_en_speed', 60) }),
    yn('skills_word_email_fax'),
    yn('steno_speed_45_bn_70_en', { name: 'steno_speed_45_bn_70_en_speed', labelKey: 'speed', ...text('steno_speed_45_bn_70_en_speed', 60) }),
    yn('training_computer_word_processing'),
    yn('typing_speed_20_bn_28_en', { name: 'typing_speed_20_bn_28_en_speed', labelKey: 'speed', ...text('typing_speed_20_bn_28_en_speed', 60) }),
    text('harvey_driving_license_number', 60),
];

export const ADDITIONAL_INFO_PREFIX = ['additional_info'];
